import React from "react";
import "./Online_degree.css";
import Common_title from "../../common_components/common-title/Common_title";

const PETALS = Array.from({ length: 8 }, (_, i) => i * 45);
const RAYS = Array.from({ length: 14 }, (_, i) => i * (360 / 14));

const BURSTS = [
  { l: "9%", t: "22%", d: "0s", c: "#ffd54f" },
  { l: "91%", t: "30%", d: "1.2s", c: "#ff4d6d" },
  { l: "16%", t: "72%", d: "2.4s", c: "#ff9800" },
  { l: "84%", t: "76%", d: "3.4s", c: "#ec407a" },
];

const Rangoli = ({ className }) => (
  <svg
    viewBox="0 0 120 120"
    className={`dwo-rangoli ${className}`}
    aria-hidden="true"
  >
    <g transform="translate(60 60)">
      {PETALS.map((a) => (
        <g key={a} transform={`rotate(${a})`}>
          <path
            d="M0 -14 C12 -28 12 -44 0 -54 C-12 -44 -12 -28 0 -14Z"
            fill="#e53935"
          />
          <path
            d="M0 -20 C6 -28 6 -37 0 -45 C-6 -37 -6 -28 0 -20Z"
            fill="#ff9800"
          />
          <circle cx="0" cy="-50" r="2.6" fill="#fff" />
        </g>
      ))}
      {PETALS.map((a) => (
        <g key={`s${a}`} transform={`rotate(${a + 22.5})`}>
          <path
            d="M0 -26 L6 -40 L0 -54 L-6 -40Z"
            fill="#8e24aa"
            opacity=".85"
          />
          <circle cx="0" cy="-34" r="2" fill="#ffd54f" />
        </g>
      ))}
      <circle r="15" fill="#ffb300" />
      <circle r="8" fill="#d81b60" />
      <circle r="3.5" fill="#fff8e1" />
    </g>
  </svg>
);

const Online_degree = () => {
  return (
    <>
      <section className="Online_degree_section">
        <div className="dwo-layer" aria-hidden="true">
          <Rangoli className="dwo-rangoli-l" />
          <Rangoli className="dwo-rangoli-r" />

          {BURSTS.map((b, i) => (
            <div
              key={i}
              className="dwo-burst"
              style={{ left: b.l, top: b.t, animationDelay: b.d, "--c": b.c }}
            >
              {RAYS.map((a) => (
                <i key={a} style={{ "--a": `${a}deg` }} />
              ))}
            </div>
          ))}
        </div>

        <div className="container">
          <Common_title
            className="text-center"
            title="DPU Online Degree Program"
            subtitle="Promotions That Resonate. Emotions That Connect."
          />

          <div className="vdosection">
            <video
              width="600"
              controls
              className="video-holder"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/video/online_degree.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* <iframe
              height="400px"
              className="video-holder"
              src="https://www.youtube.com/embed/OkM5v68Qz74?list=TLGGkHpA1KGLyicxNzExMjAyNQ"
              title="Get a Promotion with DPU Online MBA | DPUCOL - Empowering Education"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Online_degree;
